export default __webpack_public_path__ + "resources/icons/n222-62c0.webp";